export const PHONE_NUMBER_ALLOWED_PATTERN = /^[\d+\-()\s]{1,20}$/;

export function isValidPhoneNumber(value: string | null | undefined): boolean {
  if (typeof value !== "string" || value.length === 0) return false;
  if (!PHONE_NUMBER_ALLOWED_PATTERN.test(value)) return false;

  const digitCount = (value.match(/\d/g) || []).length;
  return digitCount >= 7;
}

